module.exports = __webpack_public_path__ + "img/sfondo-mela.247b2fe2.png";